export const sourceType = {
  data: {
    type: 'source-type',
    attributes: {
      name: '',
      source_type: '',
    },
    relationships: {
      sources: {
        data: [],
      },
    },
  },
};

export const sourceRules = {};

export default sourceType;
